import { OndigoNS } from '../../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.EmbedGoogleMap = function (element, init) {
        this.$element = $(element);
        this.$iframe = $('iframe', this.$element);
        this.$loader = $('.loading', this.$element);

        if(init) {
            this.init();
        } else {
            this.destroy();
        }
    };

    OndigoNS.EmbedGoogleMap.prototype = {
        init: function () {
            var scope = this;

            this.$iframe.on('load', function(e) {
                scope.$loader.hide();
                scope.$iframe.show();
                $(this).off('load');
            });

            this.$iframe.attr('src', this.$iframe.data('src'));
        },
        destroy: function () {
            this.$iframe.empty();
            this.$iframe.data('src', this.$iframe.attr('src'));
            this.$iframe.removeAttr('src');
        }
    };

    // plugin definition
    $.fn.embedGoogleMap = function (init) {
        return new OndigoNS.EmbedGoogleMap(this, init);
    };
    $.fn.embedGoogleMap.Constructor = OndigoNS.EmbedGoogleMap;

}(window.jQuery));

$(document).ready(function () {
    'use strict';
    var $googleEmbed = $('.googleEmbed');

    if($googleEmbed.length) {
        if(OndigoNS.Usercentrics.googlemapsAllowed(false)) {
            if ($googleEmbed.data('init') !== '1' && window.screen.availWidth >= OndigoNS.breakpointWide) {
                $googleEmbed.embedGoogleMap(true);
                $googleEmbed.data('init', '1');
            }

            OndigoNS.Usercentrics.googlemapsRemoveOverlay($googleEmbed, false);
        } else {
            if($googleEmbed.data('init') === '1') {
                $googleEmbed.embedGoogleMap(false);
                $googleEmbed.data('init', '0');
            }

            OndigoNS.Usercentrics.googlemapsShowOverlay($googleEmbed, false);
        }
    }

    window.addEventListener('ucEvent', function (e) {
        if($googleEmbed.length) {
            if(OndigoNS.Usercentrics.googlemapsAllowed(e)) {
                if ($googleEmbed.data('init') !== '1' && window.screen.availWidth >= OndigoNS.breakpointWide) {
                    $googleEmbed.embedGoogleMap(true);
                    $googleEmbed.data('init', '1');
                }

                OndigoNS.Usercentrics.googlemapsRemoveOverlay($googleEmbed, e);
            } else {
                if($googleEmbed.data('init') === '1') {
                    $googleEmbed.embedGoogleMap(false);
                    $googleEmbed.data('init', '0');
                }
                OndigoNS.Usercentrics.googlemapsShowOverlay($googleEmbed, e);
            }
        }
    }, false);
});